import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAPCleanup } from "./hooks/useGSAPCleanup";
import "./App.css";
import Section1Point from "./components/Section1Point";
import Section2CoreIdea from "./components/Section2CoreIdea";
import Spacer from "./components/common/Spacer";
import SectionEvidence from "./components/SectionEvidence";
import Section4Application from "./components/Section4Application";
import Section5Closing from "./components/Section5Closing";

gsap.registerPlugin(ScrollTrigger);

function App() {
  const appRef = useRef(null);
  useGSAPCleanup(); // Global GSAP cleanup

  useEffect(() => {
    // Force scroll to top on page load/refresh
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also handle page visibility changes (when returning to tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        window.scrollTo(0, 0);
      }
    };

    // Handle before unload to ensure position is reset
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    const ctx = gsap.context(() => {
      ScrollTrigger.defaults({
        markers: false,
        toggleActions: "play none none reverse",
      });

      // Refresh ScrollTrigger to ensure proper initialization
      ScrollTrigger.refresh();
    }, appRef);

    return () => {
      if (ctx) {
        ctx.revert();
      }
      // Kill all ScrollTriggers to prevent memory leaks
      ScrollTrigger.getAll().forEach((trigger) => {
        try {
          trigger.kill();
        } catch (e) {
          console.warn("Error killing ScrollTrigger:", e);
        }
      });

      // Clean up event listeners
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="App" ref={appRef}>
      <Section1Point />
      <Spacer height="50vh" className="spacer-gradient" />
      <Section2CoreIdea />
      <SectionEvidence />
      <Section4Application />
      <Section5Closing />
    </div>
  );
}

export default App;
